
	var day_rp = moment().tz('America/Los_Angeles');
	var today_rp = day_rp.days();
	var hour_rp = day_rp.hours();
	var minutes_rp = day_rp.minutes();
	var image_rp	= document.querySelector("#rocketpass")

	if (today_rp>0 && today_rp<6) {
		if (hour_rp>0 && hour_rp<14) {
			image_rp.src="weremilling.jpg"
		} else if (hour_rp>=14 && hour_rp<16) {
			image_rp.src="buyarocketpass.jpg"
		} else {
			image_rp.src="cutoff-passed.jpg"
		}
	} else {
	 image_rp.src="weekend.jpg"
	}
		console.log ("hello")